export default function Home() {
  return <h1>🏠 profile Page</h1>;
}